import styled from 'styled-components'

export const ProgramLogoContainer = styled.div<{ componentStyle?: string }>`
    ${(props) => props.componentStyle}
    display: flex;
    justify-content: space-between;
    svg {
        width: 95%;
        height: 60px;
    }
`
